import React, {useEffect, useRef} from 'react'
import { useMercadopago } from 'react-sdk-mercadopago/lib';

const Checkout = ({preference, publicKey, onCheckout = () => {}}) => {
	const buttonContainerRef = useRef(null);

	const mercadopago = useMercadopago.v2(publicKey, {
		locale: 'es-AR',
	});

	useEffect(() => {
		const mercadopagoCheckout = () => {
			return new Promise(async (resolve, reject) => {
				try {
					mercadopago.checkout({
						preference: {
							id: preference.id
						},
						render: {
							container: '.cho-container',
							label: 'Pagar',
						}
					})

					function waitForElement(selector, callback, checkFrequencyInMs, timeoutInMs) {
						var startTimeInMs = Date.now();
						(function loopSearch() {
							if (document.querySelector(selector) != null) {
								callback();
								return;
							}
							else {
								setTimeout(function () {
								if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
									return;
								loopSearch();
								}, checkFrequencyInMs);
							}
						})();
					}

					waitForElement('.cho-container > button', () => {
						resolve();
					}, 300)
				} catch (error) {
					reject(error);
				}
			})
		}

		if (mercadopago) {
			mercadopagoCheckout()
				.then(() => {
					onCheckout && onCheckout(buttonContainerRef.current)
				});
		}
	}, [mercadopago])

	return (
		<div>
            <a href={preference.init_point} style={{ display: 'none' }} className="cho-container" ref={buttonContainerRef} />
			{/* <div style={{ display: 'none' }} className="cho-container" ref={buttonContainerRef} /> */}
        </div>
	)
}

export default Checkout
